/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2V1L2NhbXBhaWducy9jcmVhdGUtbmV3LWNhbXBhaWduL2NyZWF0ZS1uZXctY2FtcGFpZ24uY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
